<template>

  <FattureScadute />
 
</template>

<script>
import FattureScadute from '../components/pratiche/FattureScadute.vue'

export default {
  components: {
    FattureScadute
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

